var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-editor", class: _vm.computedClass },
    [
      _c("QuillEditor", {
        ref: "quill",
        attrs: {
          content: _vm.value,
          disabled: _vm.disabled,
          options: _vm.OPTIONS
        },
        on: {
          blur: _vm.handleBlur,
          focus: _vm.handleFocus,
          change: _vm.handleOnChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }